<template>
    <el-dialog
        title="下发供应商"
        width="900px"
        :visible.sync="dialogVisible"
        :before-close="handleClose"
        class="issue-dialog"
    >
        <el-form
            :model="form"
            :rules="rules"
            label-width="100px"
            class="from"
            ref="ruleForm"
        >
            <el-row :gutter="10">
                <el-col :span="11">
                    <el-form-item label="承运商" prop="carrierName">
                        <advance-dialog
                            v-model="form.carrierName"
                            :params="carrierName"
                            :mValue="form.carrierName"
                            @getAdvanceValue="getCarrierNameSelectValue"
                        >
                        </advance-dialog>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item label="下游会计主体" prop="transUnitName">
                        <el-input
                            disabled
                            v-if="form.procurementChannel === '00'"
                            v-model.trim="form.transUnitName"
                        >
                        </el-input>
                        <advance-dialog
                            v-else
                            :disabled="!form.carrierName"
                            v-model="form.transUnitName"
                            :formData="form"
                            :params="transUnitNames"
                            :mValue="form.transUnitName"
                            @getAdvanceValue="getSelectValue"
                        >
                        </advance-dialog>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="whiteListCheck()">
                    <el-form-item label="发运类型" prop="shippingType">
                        <selects
                            :optionNum="'TMS_SHIPPING_TYPE'"
                            :mValue="form.shippingType"
                            @getSelectValue="getSelectValue"
                            placeholder="请选择发运类型"
                            :prop="'shippingType'"
                        ></selects>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="handleSure">保 存</el-button>
        </span>
    </el-dialog>
</template>
<script>
import advanceDialog from '@/components/lots/otpAdvance';
import { getInvoiceUnitName } from '../../api/carSchedulingDialog';
import { dictWithUrl } from '@/components/lots/api.js';
import selects from '@/components/lots/otpSelect';
import _ from 'lodash';

export default {
    components: { advanceDialog, selects },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        taskDataList: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    data () {
        return {
            form: {
                carrierCode: '',
                carrierName: '',
                transUnitName: '',
                transUnitCode: '',
                shippingType: '',
                paymentTerms: '',
                transportContractNo: '',
                updateShippingTypeTaskNos: []
            },
            unit: {}, // 自调车下游会计主体
            carrierName: {
                name: '请选择承运商',
                value: 'carrierName',
                type: 'advance',
                'advanceConfig': [
                    { 'prop': 'supplierNameCn', 'value': '承运商名称' },
                    { 'prop': 'supplierCode', 'value': '承运商编码' }
                ],
                'tableConfig': [
                    { 'prop': 'supplierNameCn', 'value': '承运商名称' },
                    { 'prop': 'supplierCode', 'value': '承运商编码' },
                    { 'prop': 'transNameListStr', 'value': '采购渠道' }
                ],
                advanceNotSearch: true,
                queryConditionRequired: true,
                method: 'post',
                advanceUrl: 'srm/supplier/search',
                prefix: '/api-tms/',
                cbParams: [
                    'supplierNameCn#carrierName', 'supplierCode#carrierCode', 'transType#procurementChannel', 'tranName#procurementChannelName'
                ]
            },
            transUnitNames: {
                'method': 'post',
                'name': '请输入下游会计主体',
                'advanceLabel': '下游会计主体',
                'value': 'transUnitName',
                'dialogWidth': '1200px',
                'advanceConfig': [
                    { 'prop': 'accountName', 'value': '下游会计主体名称' },
                    { 'prop': 'accountCode', 'value': '下游会计主体编码' }
                ],
                'tableConfig': [
                    { 'prop': 'contractName', 'value': '合同名称' },
                    { 'prop': 'legalContractCode', 'value': '法务合同号' },
                    { 'prop': 'accountName', 'value': '下游会计主体名称' },
                    { 'prop': 'accountCode', 'value': '下游会计主体编码' },
                    { 'prop': 'transportContractNo', 'value': '合同单据编码' },
                    { 'prop': 'paymentTermsName', 'value': '付款条件' },
                    { 'prop': 'remark', 'value': '背景' }
                ],
                'prefix': '/api-tms/',
                'advanceUrl': 'contract/info/matchContract',
                'cbParams': [
                    'accountName#transUnitName',
                    'accountCode#transUnitCode',
                    'paymentTerms',
                    'transportContractNo'
                ],
                'advanceCascade': 'taskDataList'
            },
            rules: {
                transUnitName: [
                    { required: true, message: '请选择下游会计主体', trigger: 'change' }
                ],
                carrierName: [
                    { required: true, message: '请选择承运商', trigger: 'change' }
                ],
                shippingType: [
                    { required: true, message: '请选择发运类型', trigger: 'change' }
                ]
            }
        };
    },
    methods: {
        getCarrierNameSelectValue (data) {
            this.form = {
                ...this.form,
                ...data
            };
            ['transUnitName', 'transUnitCode', 'paymentTerms', 'transportContractNo'].forEach(key => {
                this.form[key] = '';
            });
            //  判断是否为自调车
            if (data.procurementChannel === '00') {
                this.form.transUnitName = this.unit.transUnitName;
                this.form.transUnitCode = this.unit.transUnitCode;
            } else {
                const taskDataList = this.taskDataList.map(item => {
                    return {
                        siteCode: item.siteCode,
                        companyCode: item.companyCode,
                        businessType: item.businessType,
                        suppliersCode: data.carrierCode
                    };
                });
                this.form.taskDataList = _.unionWith(taskDataList, (item1, item2) => {
                    return item1.siteCode === item2.siteCode && item1.companyCode === item2.companyCode && item1.businessType === item2.businessType;
                });
                this.transUnitNameMethods();
            }
        },
        // 下游会计主体请求接口
        transUnitNameMethods () {
            const params = {
                pageSize: 10,
                pageNo: 1,
                taskDataList: this.form.taskDataList
            };
            getInvoiceUnitName(params).then(res => {
                if (res && +res.code === 0 && res.data.list.length === 1) {
                    const data = res.data.list[0];
                    ['paymentTerms', 'transportContractNo'].forEach(key => {
                        this.form[key] = data[key];
                    });
                    this.form.transUnitName = data.accountName;
                    this.form.transUnitCode = data.accountCode;
                }
            });
        },
        getSelectValue (data) {
            this.form = {
                ...this.form,
                ...data
            };
        },
        handleClose () {
            this.form = {};
            this.$emit('handleClose');
        },
        handleSure () {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.$emit('confirm', this.form);
                }
            });
        },
        whiteListCheck () {
            // 判断是否为零担干线公司或零担干线-网络
            const updateShippingTypeTaskNos = [];
            this.taskDataList.forEach(item => {
                if (+item.professionalCompany === 3 || +item.professionalCompany === 4) {
                    updateShippingTypeTaskNos.push(item.taskNo);
                }
            });
            if (updateShippingTypeTaskNos.length) {
                this.form.updateShippingTypeTaskNos = JSON.parse(JSON.stringify(updateShippingTypeTaskNos));
                return true;
            } else {
                return false;
            }
        }
    },
    async mounted () {
        const dic = await dictWithUrl('UNIT_NAME');
        if (dic && +dic.code === 0) {
            const UNIT_NAME = dic.data.UNIT_NAME;
            const now = new Date().getTime();
            for (const key in UNIT_NAME) {
                if (now > new Date(key.toString()).getTime()) {
                    this.unit = JSON.parse(UNIT_NAME[key]);
                }
            }
        }
    }
};
</script>
<style lang="less">
.issue-dialog {
    .el-date-editor--datetimerange.el-input__inner,
    .el-select {
        width: 100%;
    }
    .from {
        .el-form-item__content .el-input-group {
            vertical-align: middle;
        }
        .el-form-item__label,
        .el-form-item__content {
            line-height: 40px;
        }
        .el-form-item {
            margin-bottom: 14px;
        }
    }
}
</style>
